/**
 * graph008
 */
export default class {

	constructor(selector, data) {
		this.ID = selector;
		this.DATA = data;

		// objects
		this.chart;

		// init
		this.buildGraph();
	}

	buildGraph(notAddEvent) {
		if(!$(this.ID).length) return false;

		this.chart = this.Graph008_1(this.ID, this.DATA);

		this.positiontext();
		this.changeNumberToPercent();

		window.addEventListener("resize", this.positiontext.bind(this));

		window.matchMedia("print").addListener(function() {
			if($('body').hasClass("is-modal--white-print")) return false;
//			this.chart.resize();
			return false;
		});
	}

	positiontext() {
		var chartH = $("" + this.ID + " .c3-event-rect").height();
		var transformYTop = -chartH - 97;
		var transformYbot = chartH - (chartH + 53.9);
		$("p.c-graph-008_title_top").attr('style', 'transform:translateY(' + transformYTop + 'px)');
		$("p.c-graph-008_title_bottom").attr('style', 'transform:translateY('+ transformYbot + 'px)');
	}

	changeNumberToPercent() {
		var dataChart = this.chart.data.values('data');

		var total = 0;
		for(var i = 0; i < dataChart.length; i++) {
			total += dataChart[i];
		}

		var total_good = !this.DATA.data.length ? 0 : dataChart[0] + dataChart[1];
		var total_mormal = !this.DATA.data.length ? 0 : dataChart[2] + dataChart[3];
		var total_bad = !this.DATA.data.length ? 0 : dataChart[4] + dataChart[5] + dataChart[6] + dataChart[7] + dataChart[8] + dataChart[9] + dataChart[10];
		var total_bad1 = !this.DATA.data.length ? 0 : dataChart[4] + dataChart[5] + dataChart[6] + dataChart[7];
		var total_bad2 = !this.DATA.data.length ? 0 : dataChart[8] + dataChart[9] + dataChart[10];

		//add total for total label
		$(".c-graph-008_list_total-1 .c-graph-008_list_total-1--child p").text(total_bad + "人");
		$(".c-graph-008_list_total-1 .c-graph-008_list_total-2--child p").text(total_mormal + "人");
		$(".c-graph-008_list_total-1 .c-graph-008_list_total-3--child p").text(total_good + "人");
//		$(".c-graph-008_list_total-1 .c-graph-008_list_total-4--child p").text(total_bad2 + "人");

		// convert to array percent
		if(!this.DATA.data.length) return false;
		this.chart.load({
			columns: [
				[
					'data',
          this.round(dataChart[10] / total * 100, 1),
          this.round(dataChart[9] / total * 100, 1),
          this.round(dataChart[8] / total * 100, 1),
          this.round(dataChart[7] / total * 100, 1),
          this.round(dataChart[6] / total * 100, 1),
					this.round(dataChart[5] / total * 100, 1),
          this.round(dataChart[4] / total * 100, 1),
          this.round(dataChart[3] / total * 100, 1),
          this.round(dataChart[2] / total * 100, 1),
          this.round(dataChart[1] / total * 100, 1),
          this.round(dataChart[0] / total * 100, 1),
				]
			]
		});
	}

	round(value, decimals) {
		return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
	}

	Graph008_1(id, data) {
		// G, G, N, N, B, B, B, B, B, B, B
//		var colors = ["#13C959", "#13C959", "#FDB900", "#FDB900", "#FF009D", "#FF009D", "#FF009D", "#FF009D", "#FF009D", "#FF009D", "#FF009D"];
		var colors = ["#FF009D", "#FF009D", "#FF009D", "#FF009D", "#FF009D", "#FF009D", "#FF009D", "#FDB900", "#FDB900", "#13C959", "#13C959"];

		// デフォルトで10から0への降順のため逆向きに
		data.x.reverse();

		return c3.generate({
			bindto: id,
			data: {
				x: "x",
				data: "data",
				json: data,
				types: { data: 'bar' },
				labels: { data: false },
				color: function(color, d) {
					return colors[d.index];
				}
			},
			point: { show: false },
			padding: { left: 0, top: 30, bottom: 7 },
			interaction: { enabled: false },
			bar: { width: 16 },
			size: { height: 187 },
			grid: {
				y: {
					lines: [
						{ value: 100 / 10 * 10, class: 'gridline', text: "", position: "start" },
						{ value: 100 / 10 * 9, class: 'grid' },
						{ value: 100 / 10 * 8, class: 'grid' },
						{ value: 100 / 10 * 7, class: 'grid' },
						{ value: 100 / 10 * 6, class: 'grid' },
						{ value: 100 / 10 * 5, class: 'gridline', text: "", position: "start" },
						{ value: 100 / 10 * 4, class: 'grid' },
						{ value: 100 / 10 * 3, class: 'grid' },
						{ value: 100 / 10 * 2, class: 'grid' },
						{ value: 100 / 10 * 1, class: 'grid', position: "start" },
						{ value: 0, class: 'gridline' }
						/*draw line and text in graph*
						{ value: 50 / 10 * 10, class: 'gridline', text: "", position: "start" },
						{ value: 50 / 10 * 9, class: 'grid' },
						{ value: 50 / 10 * 8, class: 'grid' },
						{ value: 50 / 10 * 7, class: 'grid' },
						{ value: 50 / 10 * 6, class: 'grid' },
						{ value: 50 / 10 * 5, class: 'gridline', text: "", position: "start" },
						{ value: 50 / 10 * 4, class: 'grid' },
						{ value: 50 / 10 * 3, class: 'grid' },
						{ value: 50 / 10 * 2, class: 'grid' },
						{ value: 50 / 10 * 1, class: 'grid', position: "start" },
						{ value: 0, class: 'gridline' }
*/
					]
				},
				lines: { front: false },
			},
			legend: { show: false },
			tooltip: { show: false },
			axis: {
				x: {
					tick: { outer: false },
					type: "category",
					padding: { left: 0.8 },
				},
				y: {
					tick: { outer: false },
					max: 100,
					min: 0,
					padding: { top: 0, bottom: 39, left: 0, right: 0 }
				}
			},
			onrendered: function(e, c) {
        var axis = d3.selectAll(""+id+" .c3-axis-x");
        axis.selectAll(".c3-axis-x-label").attr("transform", "translate(10, 6)");

        var axisy = d3.selectAll(""+id+" .c3-axis-y");
        axisy.attr("transform", "translate(0,-55)");
        axisy.selectAll(".c3-axis-y-label").attr("transform", "translate(10, 6)");

        $(""+id+" svg .c3-chart-texts").attr("style","transform:translateY(-10px)");
        $(""+id+" svg .c3-chart-texts .data_label").remove();
        $(""+id+" svg .c3-chart-texts text").attr("class", "data_label").attr("y", "125");
			}
		});
	}
}

